import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { makeStyles, Switch, withStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BodyFind = styled.div`
  /* Layout Properties */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
export const CenterText = styled.text`
  font-weight: 300;
  font-size: 14px;
  display: flex;
  line-height: 21px;
  margin-bottom: 24px;
  margin-top: 32px;
  color: ${beam.font.primary};
`;
export const Description = styled.text`
  font-weight: 300;
  font-size: 12px;
  display: flex;
  margin-top: 8px;
  color: ${beam.font.primary};
`;
export const BoldText = styled.text`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  display: flex;
  color: ${beam.font.primary};
`;
export const WarningText = styled(BoldText)`
  color: #df6f00;
`;
export const FindContainer = styled.div`
  /* Layout Properties */
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  justify-items: flex-start;
  width: 100%;
  height: 100%;
`;
interface DataInputProps {
  isDisabled?: boolean;
  isVisible?: boolean;
}

export const StyledInput = styled.input`
  width: 100%;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.primary};
  background: #fff;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;
  border: 1px solid #e9edf1;
  box-sizing: border-box;

  :disabled {
    background: #f0f0f0;
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;
export const StyledTextArea = styled.textarea`
  width: 220px;
  height: 80px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.primary};
  background: #fff;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;
  border: 1px solid #e9edf1;
  box-sizing: border-box;

  :disabled {
    background: #f0f0f0;
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;
export const StyledDiv = styled.div`
  color: ${beam.font.label};
`;
export const BigUniqueFieldDiv = styled.div`
  width: 338px;
  display: flex;
  flex-direction: row;
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.label};
  background: #fff;
  justify-content: flex-start;
  align-items: center;
`;
export const GlobalInputContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 16px;
`;
export const EquipmentsListContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
`;

export const InputsContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
`;
export const RowContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: center;
`;
interface IInputDiv {
  isDisabled?: boolean;
}
export const InputDiv = styled.div<IInputDiv>`
  /* Layout Properties */
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  width: 100%;
  justify-content: start;
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};
  align-items: start;
  &.firstItem {
    margin-left: 1px;
  }
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
`;

export const BigInputDiv = styled(InputDiv)`
  /* Layout Properties */
  width: 338px;
`;

export const SmallInputDiv = styled(InputDiv)`
  /* Layout Properties */
  width: 169px;
`;
export const BigInputRowDiv = styled(BigInputDiv)`
  /* Layout Properties */
  flex-direction: row;
`;

export const FindButton = styled.button`
  font-style: normal;
  white-space: nowrap;
  cursor: pointer;
  border: none;
  height: 36px;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */
  margin-left: 16px;
  /* neutral tones/default-white */
  color: #ffffff;

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 7px;

  width: 66px;
  left: 810px;
  top: 170px;

  background: linear-gradient(90deg, #4992ff 0%, #2bc5e7 100%);
  border-radius: 8px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;

export const GlobalHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 20px;
  color: #838a91;
`;
export const Line = styled.div`
  margin-bottom: 20px;
  border: 1px solid #e9edf1;
  height: 0;
  width: 100%;
`;

export const ContainerOverflow = styled.div`
  overflow-y: auto;
  display: flex;
  height: 329px;
  flex-direction: column;
  width: 100%;
`;
export const ContainerColumn = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;
export const Label = styled.div`
  display: flex;
  align-items: center;
  color: ${beam.font.primary};
  overflow-x: hidden;
  overflow-y: hidden;
  font-size: 14px;
  width: 200px;
  position: relative;
  white-space: nowrap;
  :after {
    content: '';
    width: 40px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    right: 0;
    position: absolute;
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 70%,
      #fff 95%
    );
    height: 38px;
    z-index: 4;
  }
`;

export const BigStyledInput = styled(StyledInput)`
  width: 338px;
`;

export const BigStyledTextArea = styled(StyledTextArea)`
  width: 338px;
`;
interface LabelTextProps {
  isDisabled?: boolean;
}
export const ProductName = styled(Label)<LabelTextProps>`
  color: ${({ isDisabled }) =>
    isDisabled ? beam.font.disabled : beam.font.primary};
  font-size: 12px;
`;
export const SerialName = styled(ProductName)`
  font-size: 14px;
`;

export const BigInputWithCheckBox = styled(StyledInput)<DataInputProps>`
  width: ${({ isVisible }) => (isVisible ? '282px' : '338px')};
  border-radius: ${({ isVisible }) => (isVisible ? '8px 0 0 8px' : '8px')};
  :disabled {
    background: #fff;
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
`;
export const SmallInputWithCheckBox = styled(BigInputWithCheckBox)`
  width: ${({ isVisible }) => (isVisible ? '113px' : '169px')};
`;
export const InputWithCheckBox = styled(BigInputWithCheckBox)`
  width: ${({ isVisible }) => (isVisible ? '164px' : '220px')};
`;
export const CheckBoxDiv = styled.div`
  width: 56px;
  height: 40px;
  font-size: 10px;
  color: ${beam.font.primary};
  background: #fff;
  border: 1px solid #e9edf1;
  box-sizing: border-box;
  border-radius: 0 8px 8px 0;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
  & .MuiFormControlLabel-root {
    margin: 0 !important;
  }

  :disabled {
    background: #f0f0f0;
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;
const PurpleSwitch = withStyles({
  switchBase: {
    color: '#F0F0F0',

    '&$checked': {
      color: beam.color.primaryBlue,
    },

    '&$checked + $track': {
      backgroundColor: beam.color.primaryBlue,
      border: `none`,
    },
  },
  checked: {},
  track: {
    backgroundColor: beam.color.pureWhite,
    border: `1px solid ${beam.border.back}`,
    opacity: 1,
  },
})(Switch);

export const SwitchStyled = styled(PurpleSwitch)`
  margin-right: 8px !important;
`;

export const useStyles = makeStyles(() => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: 1,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${beam.border.back}`,
    backgroundColor: beam.border.back,
    opacity: 1,
  },
  checked: {},
  focusVisible: {},
}));
export const Image = styled.img`
  width: 43px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 16px;
`;
export const WindowButtonImage = styled.img``;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const ChangesText = styled.div`
  display: flex;
  font-size: 12px;
  white-space: nowrap;
  color: ${beam.font.primary};
  margin-right: 16px;
  margin-top: 2px;
`;
export const SaveDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 14px;
  white-space: nowrap;
  color: ${beam.color.primaryBlue};
  margin-right: 8px;
  cursor: pointer;
`;
export const IconSaveAwesome = styled(FontAwesomeIcon)`
  width: 13px;
  height: 16px;
  margin-right: 8px;
  margin-top: 2px;
`;

export const AddText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  cursor: pointer;
  /* identical to box height */

  /* beam-colors/beam-accent */
  color: #1371fe;
`;
export const Block = styled.div`
  background: #fff;
  z-index: 999;
  box-shadow: rgb(0 0 0 / 16%) 0 4px 12px;
  border-radius: 8px;
  position: absolute;
  padding: 16px 0;
  top: 46px;
  right: 19px;
  min-width: 204px;
`;
export const ItemListFirst = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 0;
  display: flex;
  color: ${beam.font.error};
  justify-content: center;
  text-align: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  :hover {
    background: ${beam.background.card};
  }
`;

export const ItemListLast = styled(ItemListFirst)`
  border-radius: 0;
  color: ${beam.font.primary};
`;
export const IconImgAwesome = styled(FontAwesomeIcon)`
  color: ${beam.font.label};
  width: 14px;
  height: 14px;
  margin-right: 8px;
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  height: 36px;
  margin-top: 8px;
  margin-bottom: 1px;
`;
export const SkipButton = styled.button`
  background: #ffffff;
  /* borders/default-border */
  border: 1px solid #e9edf1;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 8px;
  font-style: normal;
  margin-left: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height */

  /* beam-colors/beam-orange */
  color: #df6f00;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
export const Tooltip = styled.div`
  z-index: 200;
  display: flex;
`;
export const Cancel = styled.button`
  font-size: 14px;
  background: none;
  font-weight: 500;

  color: ${beam.font.primary};

  background: ${beam.color.pureWhite};
  /* borders/default-border */
  border: 1px solid ${beam.border.back};
  box-sizing: border-box;
  border-radius: 8px;
  white-space: nowrap;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: 8px 16px;
  cursor: pointer;
  margin-left: 8px;
  line-height: 18px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
export const Skip = styled.button`
  font-size: 14px;
  background: none;
  font-weight: 500;

  color: ${beam.color.pureWhite};

  background: ${beam.color.primaryBlue};
  /* borders/default-border */
  border: 1px solid ${beam.color.primaryBlue};
  box-sizing: border-box;
  border-radius: 8px;
  white-space: nowrap;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: 8px 16px;
  cursor: pointer;
  margin-left: 8px;
  line-height: 18px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
